import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import modals from '../../../enums/modals';

import { wrapPromise } from '../../../utils/promise';
import { closeTote } from '../../../store/reducers/route';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

const useCloseToteModalData = () => {
  const dispatch = useDispatch();
  const { getModalRef } = useModalContext();

  const openCloseToteModal = useCallback(async () => {
    const closeToteModalRef = getModalRef(modals.CLOSE_TOTE);
    const [, canceled] = await wrapPromise(
      closeToteModalRef.current.showModal()
    );

    if (canceled) {
      return;
    }

    dispatch(closeTote());
  }, [dispatch]);

  return {
    openCloseToteModal,
  };
};

export default useCloseToteModalData;
